import { ENTER, SPACE } from '../../constants/keys';
function handleOnKeyDown(evt, cb) {
    if (evt.key !== ENTER && evt.key !== SPACE) {
        return;
    }
    typeof cb === 'function' && cb();
}
function useButton({ as, onClick }) {
    switch (as) {
        case 'div': {
            return {
                htmlProps: {
                    tabIndex: 0,
                    role: 'button',
                    ...(typeof onClick === 'function' && {
                        onKeyDown: (evt) => handleOnKeyDown(evt, onClick),
                        onClick
                    })
                },
                a11yProps: {}
            };
        }
        case 'a': {
            return {
                htmlProps: {
                    href: '#',
                    role: 'button',
                    ...(typeof onClick === 'function' && {
                        onKeyDown: (evt) => handleOnKeyDown(evt, onClick),
                        onClick
                    })
                },
                a11yProps: {}
            };
        }
        default: {
            return {
                htmlProps: {
                    type: 'button',
                    ...(typeof onClick === 'function' && { onClick })
                },
                a11yProps: {}
            };
        }
    }
}
export { useButton };
//# sourceMappingURL=useButton.js.map